import React from 'react'

function Service() {
    return (
        <div className="container m-auto pb-20">
            <div className="texts text-center pt-20">
                <h3 className="text-[#5B2B9D] mb-5 font-bold text-lg">
                    Ideal solutions for you
                </h3>
                <h3 className="text-[#0F2137] font-black text-[16px] text-xl">
                    Didn’t find what you were looking for?
                </h3>
            </div>
            <div className="services pt-10 pb-10">
                <div className="grid md:grid-cols-4 gap-4 m-auto">
                    <div className="text-center p-5 rounded border">
                        <h3 className="text-[#0F2137] font-black text-[16px] text-base">
                            Cloud Hosting
                        </h3>
                        <h3 className="text-[#7B72F0] pt-3 font-black text-[16px] text-base">
                            $0.63/mo
                        </h3>
                    </div>
                    <div className="text-center p-5 rounded border">
                        <h3 className="text-[#0F2137] font-black text-[16px] text-base">
                        Web Hosting
                        </h3>
                        <h3 className="text-[#7B72F0] pt-3 font-black text-[16px] text-base">
                        $0.83/mo
                        </h3>
                    </div>
                    <div className="text-center p-5 rounded border">
                        <h3 className="text-[#0F2137] font-black text-[16px] text-base">
                        Wordpress Hosting
                        </h3>
                        <h3 className="text-[#7B72F0] pt-3 font-black text-[16px] text-base">
                            $0.63/mo
                        </h3>
                    </div>
                    <div className="text-center p-5 rounded border">
                        <h3 className="text-[#0F2137] font-black text-[16px] text-base">
                        Domains
                        </h3>
                        <h3 className="text-[#7B72F0] pt-3 font-black text-[16px] text-base">
                            $0.63/mo
                        </h3>
                    </div>
                    <div className="text-center p-5 rounded border">
                        <h3 className="text-[#0F2137] font-black text-[16px] text-base">
                        Email Hosting
                        </h3>
                        <h3 className="text-[#7B72F0] pt-3 font-black text-[16px] text-base">
                            $0.63/mo
                        </h3>
                    </div>
                    <div className="text-center p-5 rounded border">
                        <h3 className="text-[#0F2137] font-black text-[16px] text-base">
                        VPN Service
                        </h3>
                        <h3 className="text-[#7B72F0] pt-3 font-black text-[16px] text-base">
                            $0.63/mo
                        </h3>
                    </div>
                    <div className="text-center p-5 rounded border">
                        <h3 className="text-[#0F2137] font-black text-[16px] text-base">
                        Image Cloud
                        </h3>
                        <h3 className="text-[#7B72F0] pt-3 font-black text-[16px] text-base">
                            $0.63/mo
                        </h3>
                    </div>
                    <div className="text-center p-5 rounded border">
                        <h3 className="text-[#0F2137] font-black text-[16px] text-base">
                        VPS Hosting
                        </h3>
                        <h3 className="text-[#7B72F0] pt-3 font-black text-[16px] text-base">
                            $0.63/mo
                        </h3>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Service
